import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black text-white pt-16 pb-8 px-6 md:px-12 lg:px-16 font-sans">
      <div className="max-w-[90rem] mx-auto">
        
        {/* Top Section: Logo/Tagline and CTA */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8 mb-16 border-b border-gray-800 pb-12">
          
          {/* Logo & Tagline */}
          <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
            <div className="text-3xl font-bold tracking-tight text-white">
              <span className="font-bold">AV</span><span className="font-light">Global</span>
            </div>
            <p className="text-gray-400 text-lg font-light hidden md:block border-l border-gray-700 pl-8 py-1">
              Formando talento con mentalidad global
            </p>
            {/* Mobile tagline version without border */}
            <p className="text-gray-400 text-base font-light md:hidden">
              Formando talento con mentalidad global
            </p>
          </div>

          <a href="https://calendly.com/avconsulting-info/30min?month=2026-03" target="_blank" rel="noopener noreferrer">
            <button className="px-8 py-3 rounded-full border border-[#1a3b5c] text-[#5B9BB0] hover:bg-[#1a3b5c] hover:text-white transition-all duration-300 font-medium text-sm md:text-base">
              Agendar Asesoría Gratuita
            </button>
          </a>

        </div>

        {/* Links Grid Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-20">
          
          {/* Column 1: Servicios */}
          <div className="flex flex-col gap-6">
            <h4 className="text-xl font-bold text-gray-200">Servicios</h4>
            <ul className="flex flex-col gap-4 text-gray-400 font-light">
              <li><a href="/servicios#0" className="hover:text-[#5B9BB0] transition-colors">Programas MUN</a></li>
              <li><a href="/servicios#1" className="hover:text-[#5B9BB0] transition-colors">Orientación</a></li>
              <li><a href="/servicios#2" className="hover:text-[#5B9BB0] transition-colors">Doble Titulación</a></li>
              <li><a href="/servicios#3" className="hover:text-[#5B9BB0] transition-colors">Liderazgo</a></li>
            </ul>
          </div>

          {/* Column 2: Conoce más */}
          <div className="flex flex-col gap-6">
            <h4 className="text-xl font-bold text-gray-200">Conoce más</h4>
            <ul className="flex flex-col gap-4 text-gray-400 font-light">
              <li><a href="/nosotros#mision" className="hover:text-[#5B9BB0] transition-colors">Misión</a></li>
              <li><a href="/nosotros#mision" className="hover:text-[#5B9BB0] transition-colors">Visión</a></li>
              <li><a href="/nosotros#equipo" className="hover:text-[#5B9BB0] transition-colors">Equipo</a></li>
            </ul>
          </div>

          {/* Column 3: Legal - ACTUALIZADO */}
          <div className="flex flex-col gap-6">
            <h4 className="text-xl font-bold text-gray-200">Legal</h4>
            <ul className="flex flex-col gap-4 text-gray-400 font-light">
              <li>
                <a 
                  href="/terminos-y-condiciones.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-[#5B9BB0] transition-colors"
                >
                  Términos y Condiciones
                </a>
              </li>
              <li>
                {/* Ejemplo con atributo download si prefieres que se descargue directo */}
                <a 
                  href="/politica-de-privacidad.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-[#5B9BB0] transition-colors"
                >
                  Privacidad
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contacto */}
          <div className="flex flex-col gap-6">
            <h4 className="text-xl font-bold text-gray-200">Contacto</h4>
            <ul className="flex flex-col gap-4 text-gray-400 font-light">
              <li>San Isidro, Lima, Perú.</li>
              <li>
                <a href="mailto:info@avconsulting.com.pe" className="underline decoration-gray-600 underline-offset-4 hover:text-[#5B9BB0] hover:decoration-[#5B9BB0] transition-all">
                  info@avconsulting.com.pe
                </a>
              </li>
              <li>+51 994 381 700</li>
            </ul>
          </div>

        </div>

        {/* Bottom Section: Copyright (Left) & Socials (Right) */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 pt-8 border-t border-gray-900/50">
          
          {/* Copyright - Left */}
          <p className="text-gray-500 text-sm md:text-base font-light order-2 md:order-1">
            © 2026 AVConsulting. Todos los derechos reservados.
          </p>

          {/* Social Icons - Right */}
          <div className="flex items-center gap-6 order-1 md:order-2">
            <a 
              href="https://facebook.com/TU_PAGINA" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-400 hover:text-[#5B9BB0] transition-colors duration-300"
              aria-label="Facebook"
            >
              <i className="fa-brands fa-facebook-f text-xl"></i>
            </a>
            <a 
              href="https://instagram.com/TU_PERFIL" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-400 hover:text-[#5B9BB0] transition-colors duration-300"
              aria-label="Instagram"
            >
              <i className="fa-brands fa-instagram text-xl"></i>
            </a>
            <a 
              href="https://www.linkedin.com/company/av-global-consulting/?viewAsMember=true" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-400 hover:text-[#5B9BB0] transition-colors duration-300"
              aria-label="LinkedIn"
            >
              <i className="fa-brands fa-linkedin-in text-xl"></i>
            </a>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;